import FacebookMessengerPreview from './FacebookMessengerPreview';

export default FacebookMessengerPreview;
